module.exports = __webpack_public_path__ + "static/media/theme-icons.bb870c13.svg";